export default {
  cancel: 'Cancel',
  circle_config: 'Circle configuration',
  confirm: 'Confirm',
  confirm_delete:
    'Are you sure you want to delete this feature? This cannot be undone.',
  create: 'Create',
  csv_upload_failed: 'Data import failed, please try again.',
  csv_upload_import: 'Import From CSV',
  csv_upload_number_of_columns_imported:
    'The number of columns in your imported file',
  csv_upload_number_of_columns_required:
    'is not the same as the number of columns required',
  csv_upload_rows_imported: 'Rows Imported',
  csv_upload_success: 'Data imported successfully',
  dark_mode: 'Colour Mode',
  delete: 'Delete',
  delete_geometry: 'Delete Geometry',
  delete_vertex: 'Remove vertex',
  document_upload_failed: 'Document upload failed.',
  drag_and_drop_doc: 'Drag and drop or add document',
  drag_and_drop_image: 'Drag and drop or add image',
  draw_circle: 'Circle from Centre',
  draw_circle_2pt: 'Manual Circle',
  draw_dialog_begin_drawing: 'Begin Drawing - Click anywhere on the map',
  draw_dialog_cancel_drawing: 'Cancel Drawing - ESC Key',
  draw_dialog_remove_vertex: 'Remove Last Vertex - Right Click',
  draw_dialog_save: 'Save - Double Click',
  draw_dialog_save_single: 'Save - Single Click',
  draw_dialog_title: 'Drawing Instructions',
  draw_line: 'Line',
  draw_point: 'Point',
  draw_polygon: 'Polygon',
  draw_position: 'Current Position',
  draw_rectangle: 'Rectangle',
  edit_dialog_cancel_drawing:
    'Cancel Drawing - Click on the cancel button to cancel the drawing.',
  edit_dialog_modify_shape:
    'Edit Shape- Drag a vertex to modify the shape, or add a new vertex on the polygon.',
  edit_dialog_remove_vertex: 'Remove Vertex - Click on a vertex to remove it.',
  edit_dialog_save: 'Save - Click on the save button to save your changes.',
  edit_dialog_title: 'Editing Instructions',
  feature_info: 'Feature Info',
  filter_searchbox_placeholder: 'Search',
  icon_scaling_cluster: 'Cluster Icon Scale',
  icon_scaling_cluster_log: 'Cluster Log Scale',
  icon_scaling_field: 'Toggle Field Icon Scaling',
  icon_scaling_label: 'Icon Scale',
  icon_scaling_zoom_in: 'Zoom-in Scale',
  icon_scaling_zoom_out: 'Zoom-out Scale',
  identical_values_filter:
    'This field contains only one distinct value and cannot be filtered on.',
  image_upload_failed: 'Image upload failed.',
  information: 'Information',
  invalid_geometry: 'Invalid geometry',
  invalid_lat_lon:
    'The provided Coordinates do not fall within the selected Locale.',
  invalid_lat_long_range:
    'Invalid coordinates: Latitude and longitude values must be within valid ranges.',
  layer_add_new_location: 'Add new locations',
  layer_dataview_header: 'Data Views',
  layer_filter_clear_all: 'Clear all filters',
  layer_filter_dropdown_select: 'Select Multiple',
  layer_filter_greater_than: 'Greater than',
  layer_filter_header: 'Filter',
  layer_filter_less_than: 'Less than',
  layer_filter_reset_all: 'Reset all filters',
  layer_filter_select: 'Select filter from list',
  layer_filter_set_filter: 'Set filter',
  layer_grid_legend_ratio: 'Display colour as a ratio to the size',
  layer_group_hide_layers: 'Hide all layers in group',
  layer_style_cluster: 'Multiple locations',
  layer_style_display_hover: 'Enable hover',
  layer_style_display_labels: 'Display labels',
  layer_style_header: 'Style',
  layer_style_opacity: 'Change layer opacity:',
  layer_style_select_theme: 'Select thematic style',
  layer_style_switch_all: 'switch all',
  layer_style_switch_caption: 'Click on labels to switch visibility or',
  layer_visibility: 'Toggle visibility',
  layer_zoom_to_extent: 'Zoom to filtered layer extent',
  layers: 'Layers',
  link: 'Link',
  loading: 'Loading',
  location_clear_all: 'Clear locations',
  location_close_without_save: 'Close location without saving changes?',
  location_delete: 'Delete location',
  location_listview_full: 'The listview for locations is full.',
  location_remove: 'Remove feature from selection',
  location_save: 'Save changes to cloud',
  location_save_changes: 'Save your changes to this location?',
  location_zoom: 'Zoom map to feature bounds',
  locations: 'Locations',
  modify_geometry: 'Modify Geometry',
  no_data_filter: 'This field contains no data and cannot be filtered on.',
  no_layers: 'No accessible layers in locale.',
  no_locales:
    'Your account has been verified and approved, but you do not have access to any locales. This is likely as an administrator has not given you the required roles. Please contact an administrator to resolve this.',
  no_options_available: 'No options available.',
  no_results: 'No results for this search',
  ok: 'OK',
  pill_component_remove: 'Remove',
  pin: 'Pin',
  radius: 'Radius',
  remove_document_confirm:
    'Are you sure to remove this document? This cannot be undone.',
  remove_image_confirm:
    'Are you sure to remove the image? This cannot be undone.',
  remove_item_confirm: 'Remove item?',
  remove_last_vertex: 'Remove last vertex',
  report: 'Report',
  save: 'Save',
  toolbar_admin: 'Open account admin view',
  toolbar_current_location: 'Current location',
  toolbar_fullscreen: 'Fullscreen mapview',
  toolbar_login: 'Log in',
  toolbar_logout: 'Log out',
  toolbar_zoom_in: 'Zoom in',
  toolbar_zoom_out: 'Zoom out',
  toolbar_zoom_to_area: 'Zoom to area',
  units: 'Units',
  zoom_to: 'Zoom to Extent',
};
